import { a11yDevtoolsPlugin } from '@tanstack/devtools-a11y/react';
import { TanStackDevtools } from '@tanstack/react-devtools';
import { pacerDevtoolsPlugin } from '@tanstack/react-pacer-devtools';
import { ReactQueryDevtoolsPanel } from '@tanstack/react-query-devtools';

export const DevelopmentQueryDevtools = () => {
  return (
    <TanStackDevtools
      config={{ hideUntilHover: true }}
      plugins={[
        {
          name: 'TanStack Query',
          render: <ReactQueryDevtoolsPanel style={{ height: '100%' }} />,
        },
        pacerDevtoolsPlugin(),
        a11yDevtoolsPlugin(),
      ]}
    />
  );
};
